/* ANB hardening: jQuery presence guard */
(function(){ if (!window.$ && window.jQuery) window.$ = window.jQuery; })();
class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        (function(n){return n&&n.classList?n.classList:null})(document.querySelector('.previewCart')).add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      (function(n){return n&&n.classList?n.classList:null})(document.querySelector('.popup-toolDown.show')).remove('show');
      (function(n){return n&&n.classList?n.classList:null})(document.querySelector('.previewCart')).remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      (function(n){return n&&n.classList?n.classList:null})(document.querySelector('.popup-toolDown.show')).remove('show');
      (function(n){return n&&n.classList?n.classList:null})(document.querySelector('.previewCart')).remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
        	
      });
      (function(n){return n&&n.classList?n.classList:null})(document.querySelector('.popup-toolDown.show')).remove('show');
      (function(n){return n&&n.classList?n.classList:null})(document.querySelector('.previewCart')).remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);

/* ANB: intercept upsell card Add To Cart inside cart drawer */
(function() {
  function bindUpsellAddToCart() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.previewCartCollection .button-ATC, .previewCartCollection [data-btn-addToCart]');
      if (!btn) return;
      
      var form = btn.closest('form');
      if (!form) return;
      
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      
      var formData = new FormData(form);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/javascript' }
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Add failed');
        return res.json();
      })
      .then(function() {
        // Set flag so drawer reopens after reload
        try { sessionStorage.setItem('anbReopenCartDrawer', '1'); } catch(e) {}
        window.location.reload();
      })
      .catch(function(err) {
        console.error('Upsell add failed:', err);
        btn.disabled = false;
        btn.textContent = originalText;
      });
    }, true);
  }
  
  function reopenDrawerIfFlagged() {
    try {
      if (sessionStorage.getItem('anbReopenCartDrawer') === '1') {
        sessionStorage.removeItem('anbReopenCartDrawer');
        setTimeout(function() {
var trigger = document.querySelector('[data-cart-sidebar], [data-open-cart-sidebar], .cart-icon-bubble, .header__icon--cart, [href="#halo-cart-sidebar"]');          if (trigger) trigger.click();
        }, 400);
      }
    } catch(e) {}
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      bindUpsellAddToCart();
      reopenDrawerIfFlagged();
    });
  } else {
    bindUpsellAddToCart();
    reopenDrawerIfFlagged();
  }
})();

/* ANB: intercept upsell card Add To Cart inside cart drawer */
(function() {
  function bindUpsellAddToCart() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.previewCartCollection .button-ATC, .previewCartCollection [data-btn-addToCart]');
      if (!btn) return;
      
      var form = btn.closest('form');
      if (!form) return;
      
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      
      var formData = new FormData(form);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/javascript' }
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Add failed');
        return res.json();
      })
      .then(function() {
        // Fetch fresh cart drawer HTML
        return fetch('/?sections=halo-cart-sidebar', { cache: 'no-store' });
      })
      .then(function(r) {
        if (r) return r.json();
        return null;
      })
      .then(function(sections) {
        var drawer = document.getElementById('halo-cart-sidebar');
        if (sections && sections['halo-cart-sidebar'] && drawer) {
          // Parse and replace drawer contents
          var temp = document.createElement('div');
          temp.innerHTML = sections['halo-cart-sidebar'];
          var newDrawer = temp.querySelector('#halo-cart-sidebar');
          if (newDrawer) {
            drawer.innerHTML = newDrawer.innerHTML;
          }
        }
        // Update count badges
        return fetch('/cart.js', { cache: 'no-store' })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function(el) {
              el.textContent = cart.item_count;
            });
            btn.disabled = false;
            btn.textContent = originalText;
          });
      })
      .catch(function(err) {
        console.error('Upsell add failed, falling back to reload:', err);
        try { sessionStorage.setItem('anbReopenCartDrawer', '1'); } catch(e) {}
        window.location.reload();
      });
    }, true);
  }
  
  function reopenDrawerIfFlagged() {
    try {
      if (sessionStorage.getItem('anbReopenCartDrawer') === '1') {
        sessionStorage.removeItem('anbReopenCartDrawer');
        setTimeout(function() {
          var trigger = document.querySelector('[data-cart-sidebar], [data-open-cart-sidebar], .cart-icon-bubble, .header__icon--cart, [href="#halo-cart-sidebar"]');
          if (trigger) trigger.click();
        }, 400);
      }
    } catch(e) {}
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      bindUpsellAddToCart();
      reopenDrawerIfFlagged();
    });
  } else {
    bindUpsellAddToCart();
    reopenDrawerIfFlagged();
  }
})();